import { render, staticRenderFns } from "./event-details-view.vue?vue&type=template&id=3b6f72c2&scoped=true&"
import script from "./event-details-view.vue?vue&type=script&lang=js&"
export * from "./event-details-view.vue?vue&type=script&lang=js&"
import style0 from "./event-details-view.vue?vue&type=style&index=0&id=3b6f72c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f72c2",
  null
  
)

export default component.exports